import React, { useState } from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  Button,
} from "shards-react";
import DatePicker from "react-datepicker";
import UploadReportPDF from "./UploadReportPDF";
import ProgressBarReports from "./ProgressBarReports";

export default function AddPastReportCard({ selectedUser }) {

  const [startDate, setStartDate] = useState(new Date());
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
  const [file, setFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  // Checks if the type is image or pdf and assigns the content type
  const handleFileUpload = (e) => {
    e.preventDefault()

    setLoading(true)

    if (selectedFile && selectedFile.type === 'application/pdf') {
      setFile(selectedFile);
      setError('');
    } else {
      setFile(null);
      setError('Please select a PDF document');
    }
    setLoading(false)
  };

  const handleFileSelect = (e) =>{
    let selectedFile = e.target.files ? e.target.files[0] : null;
    setSelectedFile(selectedFile);
  }

  
  return (
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">Upload Past Report</h6>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              <Form onSubmit={handleFileUpload}>
                <Row form>
                  {/* File Date */}
                  <Col md="12" className="form-group">
                    <label className="d-flex">Report Date</label>
                    <DatePicker
                      disabled={!selectedUser}
                      className="form-control"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      required
                      placeholder="Due Date"
                    />
                  </Col>
                  <Col md="12" className="form-group">
                    {/* Upload Report PDF */}
                    <label htmlFor="feImage">Attach PDF</label>
                    <UploadReportPDF userId={selectedUser ? selectedUser.id : null} handleFileSelect={handleFileSelect} error={error} file={file} selectedFile={selectedFile}/>
                    {file && <ProgressBarReports userId={selectedUser ? selectedUser.id : null} file={file} setFile={setFile} date={startDate}/>}
                  </Col>
                  <Col md="12" className="form-group">
                    <Button type="submit" disabled={loading || !selectedUser } className="d-flex" theme="primary">Upload Report</Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
  )
}
